module.exports = __webpack_public_path__ + "static/media/Icons_text_block.518f48b2.svg";